import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Flex, Image, Box, Spacer } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faHome } from "@fortawesome/free-solid-svg-icons";

export const Header = () => {
  const navigate = useNavigate();
    const [user, setUser] = useState(null);
  
    useEffect(() => {
      const current = JSON.parse(localStorage.getItem("currentUser"));
      setUser(current);
    }, []);

  return (
    <Box shadow="lg">
    <Flex gap="4" justify="space-between" alignItems="center">
      <Image src="/logo-header.png" ml={10} mt={2} h="50px" />
      <Box mr={10}>
        {(user) &&
        <FontAwesomeIcon
          icon={faGear}
          size="xl"
          onClick={() => navigate("/menu")}
          color="#117587"
        />}
      </Box>
    </Flex>
    <Box w="100%" bgColor="#4ca079" h="2px" mt={2}/>
    </Box>
  );
};
